import { Directive, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { BreakpointHelperService, ScreenType } from '../services';

@Directive({
  selector: '[customerScreenType]',
})
export class ScreenTypeDirective implements OnDestroy {
  private readonly subscription: Subscription;

  constructor(
    private readonly breakpointHelperService: BreakpointHelperService,
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
  ) {
    this.subscription = this.breakpointHelperService.screenType$.subscribe(
      (screenType: ScreenType) => {
        this.updateClass(screenType);
      },
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateClass(screenType: ScreenType): void {
    const element = this.el.nativeElement;
    /** Remove all screen classes */
    this.renderer.removeClass(element, 'isSmall');
    this.renderer.removeClass(element, 'isMedium');
    this.renderer.removeClass(element, 'isLarge');
    this.renderer.removeClass(element, 'isXLarge');

    switch (screenType) {
      case 'small':
        this.renderer.addClass(element, 'isSmall');
        break;
      case 'medium':
        this.renderer.addClass(element, 'isMedium');
        break;
      case 'large':
        this.renderer.addClass(element, 'isLarge');
        break;
      case 'extra-large':
        this.renderer.addClass(element, 'isXLarge');
        break;
      default:
        this.renderer.addClass(element, 'isMedium');
        break;
    }
  }
}
